import { useContext } from "react";
import { AuthContext } from "@CONTEXTS";
import { Button, Menu, Dropdown, Modal, message } from "antd";
import { deleteReceiver } from "@RECEIVERS";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  AiFillDelete,
  AiOutlineEdit,
  AiOutlineDown,
  AiOutlineUserAdd,
} from "react-icons/ai";

const { confirm } = Modal;

const useLogics = ({
  onLoading,
  mutate,
  fieldName,
  form,
  onClose,
  setStep,
  setUpdateValues,
  isReturned,
}) => {
  const { info } = useContext(AuthContext);

  const confirmDelete = async (id) => {
    if (!info.authorities.includes("RECEIVER_DELETE")) {
      return message.error("Kişi silme yetkiniz bulunmamaktadır!");
    }
    confirm({
      title: "Silmek İstediğinize emin misiniz?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Kişiyi silmek istediğinizden emin misiniz? Onaylarsanız kalıcı olarak silinecektir. Devam etmek istiyor musunuz?",
      onOk() {
        return new Promise(async (resolve) => {
          onLoading(true);
          const response = await deleteReceiver(id);
          if (response) {
            mutate();
          }
          onLoading(false);
          resolve();
        });
      },
      onCancel() {},
    });
  };

  const menu = (record) => {
    return (
      <Menu>
        <Menu.Divider />
        <Menu.Item
          key="1"
          icon={<AiOutlineUserAdd style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            let tempForm = form.getFieldsValue();
            if (isReturned) {
              tempForm.firstName = record.firstName;
              tempForm.lastName = record.lastName;
              tempForm.phone = record.phone;
              tempForm.city = record.address.city?.name;
              tempForm.town = record.address.town?.name;
              tempForm.district = record.address?.district?.name;
              tempForm.addressLine = record.address?.addressLine;
            } else {
              tempForm[fieldName].recipientName = record.firstName;
              tempForm[fieldName].recipientSurname = record.lastName;
              tempForm[fieldName].recipientPhone = record.phone;
              tempForm[fieldName].recipientCity = record.address.city?.name;
              tempForm[fieldName].recipientTown = record.address.town?.name;
              tempForm[fieldName].recipientDistrict =
                record.address?.district?.name;
              tempForm[fieldName].recipientAddressLine =
                record.address?.addressLine;
            }

            form.setFieldsValue(tempForm);
            onClose();
          }}
        >
          Alıcıyı Kullan
        </Menu.Item>
        <Menu.Item
          key="2"
          icon={<AiOutlineEdit style={{ marginRight: 5 }} />}
          onClick={(e) => {
            if (!info.authorities.includes("UPDATE_RECEIVER")) {
              return message.error("Kişi düzenleme yetkiniz bulunmamaktadır!");
            }
            e.domEvent.stopPropagation();
            setUpdateValues(record);
            setStep("UPDATE");
          }}
        >
          Alıcıyı Düzenle
        </Menu.Item>
        <Menu.Item
          key="6"
          danger
          icon={<AiFillDelete style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            confirmDelete(record.id);
          }}
        >
          Alıcıyı Sil
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "Ad",
      key: "firstName",
      dataIndex: "firstName",
      width: 150,
    },
    {
      title: "Soyad",
      key: "lastName",
      dataIndex: "lastName",
      width: 150,
    },
    {
      title: "Telefon",
      dataIndex: "phone",
      key: "phone",
      width: 150,
      render: (_, record) => `${record.phone}`,
    },
    {
      title: "İl",
      dataIndex: "city",
      key: "city",
      width: 150,
      render: (_, record) => ` ${record.address?.city.name.toUpperCase()}`,
    },
    {
      title: "İlçe",
      dataIndex: "town",
      key: "town",
      width: 150,
      render: (_, record) => `${record.address?.town.name?.toUpperCase()}`,
    },
    {
      title: "Mahalle",
      dataIndex: "district",
      key: "district",
      width: 150,
      render: (_, record) =>
        `${
          record.address?.district?.name
            ? record.address?.district?.name?.toUpperCase()
            : ""
        }`,
    },

    {
      title: "İşlemler",
      width: 80,
      render: (_, record) => (
        <Dropdown overlay={menu(record)} placement="bottomRight">
          <Button type="primary" size="small" block>
            <span>
              İşlemler <AiOutlineDown style={{ left: 5 }} />
            </span>
          </Button>
        </Dropdown>
      ),
    },
  ];

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
